'use strict';

import showBrowseItem from 'templates/showBrowse/__showBrowseItem.tpl';
import movieBrowseItem from 'templates/movieBrowse/__movieBrowseItem.tpl';
import 'carousels/helpers/ellipsify';
import 'components/subnav';
import { trackAction, trackView } from 'helpers/trackingOM';
import ShowBrowse from 'components/showBrowse';
import GridImpressionTracking, { hasGridImpressionTracking } from 'shared/gridImpressionTracking';

const BRANDS_CONTENT_TYPE = 'brands';
const MOVIES_CONTENT_TYPE = 'movies';

export default class Browse {
    constructor(contentType) {
        this.contentType = contentType;
        this.hasImpresionTracking = hasGridImpressionTracking();
        this.impressionTracking = null;
        this.__initMetaData();
        this.__initNavButtons();
        this.__initContainers();
        this.__initParameters();
        this.__listenEvents();
        this.__setUpNavButtonsListeners();
        this.__loadMoreButtonAction();
        this.__initRoutePrefix();
        this.__initImpressionTracking();
        this.__currentXHR = null;
        CBS.Promises.Tracking.onLoad(() => {
            let showBrowseItems = document.querySelectorAll('.show-browse-item');
            this.__initTracking(showBrowseItems);
        });
    }

    __initTracking(elements) {
        let _self = this;
        for (let i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', (event) => {
                let elem = elements[i];
                if (_self.contentType === BRANDS_CONTENT_TYPE) {
                    _self.trackBrandRowHeader(elem);
                } else {
                    _self.trackBrowseTile(elem);
                }
            });
        }
    }

    trackBrandRowHeader(el) {
        const anchorElement = el.firstElementChild;
        // Can be used here closest() and pass to it the selector?
        const parentCarouselElement = el.parentElement.parentElement;

        const aaLink = anchorElement.getAttribute('aa-link');
        const movieId = anchorElement.getAttribute('movie_id');
        const showId = anchorElement.getAttribute('show_id');
        const showGenre = anchorElement.getAttribute('category');

        const aaLinkArray = aaLink?.split('|');
        const positionColNumber = String(aaLinkArray[3] - 1);
        const rowHeaderTitle = parentCarouselElement.firstElementChild.innerText;
        const positionRowNumber = String(
            Array.from(parentCarouselElement.parentNode.children).indexOf(parentCarouselElement),
        );

        const data = {
            contentBrand: this.category, //"<brand name>”, // e.g. “smithsonian”
            posColNum: positionColNumber, //"<position within the carousel with count starting from 0>", // e.g. “0”
            posRowNum: positionRowNumber, //"<position of the carousel within the page with count starting from 0>", // in this case since there is no hero, the first carousel would have the 0 position; e.g. “0”
            rowHeaderTitle: rowHeaderTitle, // "<carousel title>" // e.g. “trending”, “a-z”, etc.
        };
        if (movieId) {
            data['movieGenre'] = showGenre;
            data['movieId'] = movieId;
            data['movieTitle'] = aaLinkArray[4];
        } else {
            data['showGenre'] = showGenre;
            data['showSeriesId'] = showId;
            data['showSeriesTitle'] = aaLinkArray[4];
        }
        trackAction('trackBrandRowHeader', data);
    }

    trackBrowseTile(el) {
        let _self = this;
        let $el = $(el);
        let $link = $el.find('a');
        let dd = $link.attr('aa-link');
        if (dd) {
            dd = dd.split('|');
        }
        let category = dd[0] ?? _self.category;

        var scrollPosition = $(document).scrollTop();
        sessionStorage.setItem('scrollPosition_movies_' + category, scrollPosition.toString());
        let section_title = $el.parent().prev().text();
        section_title = section_title.indexOf('alphabetically') === -1 ? section_title : 'Popular';

        let _parent = $el.parent();
        let _grandparent = _parent.parent();
        let _grids = _grandparent.find('div.show-browse-grid');
        let rowNum;

        for (let i = 0; i < _grids.length; i++) {
            if (_parent[0] === _grids[i]) {
                rowNum = i;
            }
            rowNum = rowNum === 0 ? '0' : rowNum; //tracking treats int 0 as boolean and doesn't capture the value
        }
        let _sibs = _parent.find('article.show-browse-item');
        let colNum = 0;
        for (let i = 0; i < _sibs.length; i++) {
            if ($el[0] === _sibs[i]) {
                colNum = i;
            }
            colNum = colNum === 0 ? '0' : colNum;
        }

        let rowHeaderTitle = category == 'all' || category == '' ? 'All Shows' : category;
        let badgeLabel = $link.find('.new-item').text();

        let data = {
            pageType: 'category_door',
            pageURL: '/shows/' + category + '/',
            screenName: 'shows/' + category,
            showBrowseCategory: rowHeaderTitle,
            showGenre: category,
            showSeriesId: typeof dd[5] !== undefined ? dd[5] : '',
            showTitle: typeof dd[4] !== undefined ? dd[4] : '',
            showSeriesTitle: typeof dd[4] !== undefined ? dd[4] : '',
            PPlusSubscriberBadge: typeof dd[14] !== undefined ? dd[14] : '',
            rowHeaderTitle: rowHeaderTitle,
            posRowNum: rowNum,
            posColNum: colNum,
            contentLocked: dd[23],
            contentBadgeLabel: badgeLabel ?? '',
        };

        if (typeof om != 'undefined') {
            om.trackAction('trackShowBrowseTileSelect', data);
        }
        localStorage.setItem('trackShowBrowseTileSelect', JSON.stringify(data));
    }

    __initMetaData() {
        this.metaTitle = $('title');
        this.metaDesc = $('meta[name="description"]');
        this.metaOgTitle = $('meta[property="og:title"]');
        this.metaOgDesc = $('meta[property="og:description"]');
    }

    __initRoutePrefix() {
        this._routePrefix = this.__buildRoutePrefix();
    }

    __buildRoutePrefix() {
        if (this.contentType === BRANDS_CONTENT_TYPE) {
            return CBS.Registry.region.prefix + '/brands_home_xhr/';
        } else if (this.contentType === MOVIES_CONTENT_TYPE) {
            this.isMovie = true;
            return CBS.Registry.region.prefix + '/movies_xhr/';
        } else {
            return CBS.Registry.region.prefix + '/shows_xhr/';
        }
    }

    __initNavButtons() {
        this.buttons = $('.subnav__items a');
    }

    __initContainers() {
        this.container = $('.browse-container, .brands-home-container');
        this.gridContainer = this.container.find('.browse-grid, .grid');
        this.loadMoreButton = $('.browse-more-bottom');
        this.total =
            this.gridContainer.data('total') ||
            this.container.data('movies-found') ||
            this.container.data('items-found');
        this.gid = this.gridContainer.data('gid') || null;
        this.category =
            this.contentType === BRANDS_CONTENT_TYPE
                ? document.location.pathname.split('/')[2]
                : this.gridContainer.data('category') || 'a-z';
        this.groupType = this.gridContainer.data('grouptype') || null;
        this.observer = null;
        this.isMovie = false;
    }

    __initParameters() {
        this.start = 0;
        this.resp = '';
        this.startCount = this.gridContainer.children().length || 0;
    }

    __listenEvents() {
        $(this).on('showBrowseDidRender', () => {
            // reinitialize blazy object
            if (CBS.Registry.lazyImage !== undefined) {
                setTimeout(() => {
                    CBS.Registry.lazyImage.revalidate();
                }, 100);
            }
            try {
                this.container.ellipsify();
            } catch (e) {
                console.log('We caught ellipsify error exception!');
            }
        });
    }

    __setLoadMoreButtonActions() {
        this.loadMoreButton.click((event) => {
            this.start += 1;
            event.preventDefault();
            this.__load();
        });

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.start += 1;
                    this.__load();
                }
            });
        }, {});

        this.observer.observe(this.loadMoreButton[0]);
    }

    __checkNeedLoadMore() {
        return this.startCount < this.total;
    }

    __loadMoreButtonAction() {
        if (this.__checkNeedLoadMore()) {
            this.loadMoreButton.show();
            if (!this.observer) {
                this.__setLoadMoreButtonActions();
            }
        } else {
            this.loadMoreButton.hide();
        }
    }

    __setUpNavButtonsListeners() {
        this.buttons.click((e) => {
            let btn = $(e.target);

            if (!btn.hasClass('active')) {

                if (btn.data('gid')) {
                    this.gid = btn.data('gid');
                }

                if (btn.data('category')) {
                    this.category = btn.data('category');
                }

                if (btn.data('grouptype')) {
                    this.grouptype = btn.data('grouptype');
                }

                trackView({
                    pageType: 'category_door',
                    siteHier: 'category_door',
                    pageUrl:
                        window.location.protocol +
                        '//' +
                        window.location.host +
                        '/' +
                        this.category,
                });
            }
        });
    }

    __resetGrid() {
        this.gridContainer.empty();
    }

    __load() {
        this.__currentXHR = $.ajax({
            url: this.__buildXhrRoute(),
            dataType: 'json',
        }).done((resp) => {
            this.__currentXHR = null;
            if (!resp || !resp.success) {
                this.loadMoreButton.hide();
                return;
            }

            if (typeof resp.data !== 'undefined' && resp.data.length > 0) {
                this.__handleMultiItemResp(resp);
                this.destroyImpressionTracking();
                this.createImpressionTracking();
            } else {
                this.resp = resp.result;
                this.total = resp.result.total;
                this.__processRespItem();
            }
        });
    }

    //Method to handle responses with multiple categories (e.g., trending and movies)
    __handleMultiItemResp(resp) {
        let self = this;
        $.each(resp.data, function (i, item) {
            self.resp = item.result;
            self.total = item.result.total;
            self.__processRespItem();
        });
    }

    __processRespItem() {
        if (this.resp.data.length) {
            this.startCount += this.resp.data.length;
        }

        this.__manipulateMeta();

        if (this.resp && this.resp.data) {
            const $gridTemplate = $(this.__parseGrid(this.resp));
            this.__initTracking($gridTemplate);
            $(this.gridContainer).append($gridTemplate);
            $(this).trigger('showBrowseDidRender');
            this.__loadMoreButtonAction();
        }
    }

    __manipulateMeta() {
        if (this.resp.seo) {
            let seo = this.resp.seo;
            this.metaTitle.text(seo.meta_title);
            this.metaDesc.attr('content', seo.meta_description);
            this.metaOgTitle.attr('content', seo.social_title);
            this.metaOgDesc.attr('content', seo.social_description);
        }
    }

    __buildXhrRoute() {
        return !this.isMovie && this.contentType !== BRANDS_CONTENT_TYPE
            ? `${this._routePrefix}${this.gid}/${this.start}/${this.groupType}/`
            : `${this._routePrefix}${this.category}/${this.start}/`;
    }

    __parseGrid(result) {
        let grid = '';

        // render the items to the grid container ^
        result.data.forEach((obj, idx) => {
            let o = obj;
            o.pos = idx + 1;
            o.category = this.category;
            if (typeof o.thumb === 'undefined') {
                o.thumb = o.poster;
            }
            grid += this.isMovie ? movieBrowseItem(o) : showBrowseItem(o);
        });

        return grid;
    }

    __initImpressionTracking() {
        if (this.hasImpresionTracking) {
            this.createImpressionTracking();
        }
    }

    destroyImpressionTracking() {
        if (this.impressionTracking) {
            this.impressionTracking.removeEvents();
            this.impressionTracking = null;
        }
    }

    createImpressionTracking() {
        let containers = [];
        let showBrowseGrid = document.querySelectorAll('.show-browse-grid');

        if (showBrowseGrid.length) {
            containers = [...showBrowseGrid];
        }

        let objTracking = {
            pageType: CBS.Registry?.pageType ?? 'CATEGORY_DOOR',
        };

        this.impressionTracking = new GridImpressionTracking(
            containers,
            'carouselView',
            'carouselSelect',
            objTracking,
        );
    }
}
